import { useEffect, useState } from 'react';

/**
 * Hook to track document visibility state.
 * Returns true when the document is visible, false when it's hidden (e.g., tab is inactive).
 */
export const useDocumentVisibility = (): boolean => {
  const [isVisible, setIsVisible] = useState(!document.hidden);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isVisible;
};
